/* istanbul ignore file */
import React from 'react';
import { ListBreadcrumbItem, Breadcrumbs } from 'framework/ui/BreadCrumbs';
import { useContractsUrl } from 'domain/people/contracts/contractsRouting';

const ContractsBreadcrumbs = ({ children = null }: { children?: React.ReactNode }) => {
  const { getListUrl } = useContractsUrl();

  return (
    <Breadcrumbs>
      <ListBreadcrumbItem entity="Contracts" link={getListUrl()} />
      {children}
    </Breadcrumbs>
  );
};

export default ContractsBreadcrumbs;
